<template>
  <div class="grid grid-cols-12 gap-0 bg-gray-100 dark:bg-gray-800 font-medium text-right py-1 px-2 border-t-2 border-gray-300 dark:border-gray-600">
    <div class="col-span-6"></div>
    <div class="col-span-1 text-center">
      <span class="font-medium text-sm">{{ totalHours }}h</span>
    </div>
    <div class="col-span-1 text-center">
      <span class="font-mono font-medium text-sm">€{{ chargedTotal }}</span>
    </div>
    <div class="col-span-1 text-center">
      <span class="font-mono font-medium text-sm">€{{ actualTotal }}</span>
    </div>
    <div class="col-span-1 text-center">
      <span class="font-mono font-medium text-sm">€{{ quoteTotal }}</span>
    </div>
    <div class="col-span-1"></div>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  totalHours: number;
  chargedTotal: string;
  actualTotal: string;
  quoteTotal: string;
}>();
</script>
